<div class="app-button-container app-flex app-flex-middle">
  <div
    class="app-button-input-container app-flex app-flex-column app-flex-middle"
  >
    <span class="app-key app-continue-key">
      {{ keyLabel | titlecase }}
    </span>
    <button
      value="continue"
      class="app-btn app-btn-hov-green"
      (click)="triggerDecision(true)"
    >
      {{ continueButtonLabel }}
    </button>
  </div>
</div>
